import React from 'react';

import { charts, views } from '../../constants/event';
import EventChart from '../../chart/EventChart';
import LabelsWrapper from './LabelsWrapper';

const EventsResult = (props) => {
  const { options } = props;

  return (
    <div>
      {charts.includes(options.view) && <EventChart {...props} />}
      {options.view === views.CHART && <LabelsWrapper {...props} />}
    </div>
  );
};

export default EventsResult;
